import { createFileRoute } from '@tanstack/react-router'
import { FaqSectionOne } from '@/components/faq/FaqSectionOne'
import { FaqSectionTwo } from '@/components/faq/FaqSectionTwo'

export const Route = createFileRoute('/faq/')({
	head: () => ({
		meta: [
			{ title: 'Wellview Care FAQ: Expert STD Testing & Treatment Services in Southeast Florida' },
			{
				name: 'description',
				content:
					'Discover Wellview Care`s expert STD testing and treatment, including rapid tests, advanced HIV & Hep-C treatments, and telehealth' +
					' services. Your guide to sexual health in Southeast Floria',
			},
			{
				name: 'keywords',
				content:
					'STD/STI testing, STD Testing, HIV Testing,	Hepatitis C Virus (HCV), Chlamydia Testing, Gonorrhea Testing, Syphilis Testing, STD' +
					' Treatment, EPCLUSA® for HCV, BIKTARVY® for HIV, HIV Prevention, Pre-Exposure Prophylaxis (PrEP), Post-Exposure Prophylaxis (PEP),' +
					' Telehealth Services, STD Prevention, Rapid STD Tests, HIV and Hep-C Rapid Tests, Comprehensive STD Lab Panel, HIV Symptoms, Hepatitis' +
					' C Symptoms, Antiretroviral Therapy, Fort Lauderdale STD Services, Riviera Beach STD Services   ',
			},
		],
	}),
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<>
			<FaqSectionOne />
			<FaqSectionTwo />
		</>
	)
}
